import { HelpFeature, HelpModel } from '@/model/HelpModel';
import { createSelector } from 'reselect';
import { RootReducer } from '../rootReducer';
import { HelpState } from './reducers';

const helpSelector = (state: RootReducer) => state.helpReducer;

export const selectHelpRoutes = createSelector(helpSelector, (helpState: HelpState): Map<HelpFeature, HelpModel[]> => helpState.helpRoutes);
